// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"685":"f3756afd6c62ecb4","1497":"90ccde44ad998b78","2511":"f629c6923c2d04ff"}[chunkId] + ".js";
};